
import { useState } from 'react';

import BuySellLoginContent from './BuySellLoginContent';
import BuySellLoginFail from './BuySellLoginFail';
import BuySellLoggedContent from './BuySellLoggedContent';
import BuySellLoggedTwoFactor from './BuySellLoggedTwoFactor';
import BuySellLoggedVerfication from './BuySellLoggedVerfication';
import Footer from '../Footer/Footer';
import { Route, Routes } from 'react-router-dom';
import BuySellForgotPassword from './BuySellForgotPassword';
import BuySellVerifyEmail from './BuySellVerifyEmail';
import BuySellResetPassword from './BuySellResetPassword';
import RedirectIfSignedIn from '../RedirectIfSignedIn';

const BuySellLogin = () => {
    const [screenName, setScreenName] = useState("");
    console.log(screenName);
    return (
        <>
            <div className='scan-container flex-align-stretch bs_main'>

                {/* Signed-in visitors skip the login form and its code steps;
                    forgot/reset password stay open so an emailed link always works. */}
                <Routes>
                    <Route index element={<RedirectIfSignedIn><BuySellLoginContent setScreenName={setScreenName} /></RedirectIfSignedIn>} />
                    <Route path="forgot-password" element={<BuySellForgotPassword />} />
                    <Route path="reset-password" element={<BuySellResetPassword />} />
                    <Route path="fail" element={<RedirectIfSignedIn><BuySellLoginFail setScreenName={setScreenName} /></RedirectIfSignedIn>} />
                    <Route path="email-auth" element={<RedirectIfSignedIn><BuySellVerifyEmail /></RedirectIfSignedIn>} />
                    <Route path="locked" element={<RedirectIfSignedIn><BuySellLoggedContent setScreenName={setScreenName} /></RedirectIfSignedIn>} />
                    <Route path="mob-auth" element={<RedirectIfSignedIn><BuySellLoggedTwoFactor setScreenName={setScreenName} /></RedirectIfSignedIn>} />
                    <Route path="ssn-auth" element={<RedirectIfSignedIn><BuySellLoggedVerfication setScreenName={setScreenName} /></RedirectIfSignedIn>} />
                </Routes>

            </div>
            <Footer footerArt="flipWoman" />
        </>
    )
}

export default BuySellLogin